import React from "react";
import '../css/Projects.css';

// Import Images
import sjmhss from '../images/stjosephs.png';
import fuel from '../images/fuel.png';
import ups from '../images/ups.jpeg';
import portfolio from '../images/portfolio.png';

// Import Icons
import { FaReact, FaJsSquare, FaCss3Alt, FaHtml5, FaPhp } from 'react-icons/fa';
import { SiTailwindcss } from 'react-icons/si';
import { MdOutlineLaunch } from "react-icons/md";
import { SiGithub } from 'react-icons/si';

// Components
import Badge from "./Badge";
import Card from "./Card";
import MacWindow from "./MacWindow";

// --- HTML PROJECTS DATA ---
const htmlProjectsData = [
    {
        title: "St. Josephs",
        subtitle: "Landing Page Design",
        description: "St. Josephs MHSS is my alma mater, an excellent school with best management for both academics and sports.",
        accentColor: "#1255f3ff",
        url: "stjosephsondipudur.com",
        liveLink: "https://www.stjosephsondipudur.com/",
        githubLink: "https://github.com/aswinlegarcon/School-Website-St.Josephs",
        image: sjmhss,
        stack: [
            { icon: <FaHtml5 />, name: "HTML" },
            { icon: <FaCss3Alt />, name: "CSS" },
            { icon: <FaPhp />, name: "PHP" },
            { icon: <FaJsSquare />, name: "Javascript" },
        ]
    },
    {
        title: "FUEL",
        subtitle: "Page Design",
        description: "Fuel is a merit-based scholarship program offering students financial aid, expert mentoring, skill training and internships.",
        accentColor: "#ff0051ff",
        url: "fuelmyfuture.org",
        liveLink: "https://fuelmyfuture.org/",
        githubLink: "https://github.com/aswinlegarcon/project_fuel.git",
        image: fuel,
        stack: [
            { icon: <FaHtml5 />, name: "HTML" },
            { icon: <FaPhp />, name: "PHP" },
            { icon: <FaCss3Alt />, name: "CSS" },
            { icon: <FaJsSquare />, name: "Javascript" },
        ]
    },
    {
        title: "UPS",
        subtitle: "Lead Generation Website",
        description: "A professional B2B Product Catalog for an Authorized Honda Dealer with custom Request-for-Quote workflow and sleek industrial design.",
        accentColor: "#ff0000ff",
        url: "universalpowersystems.in",
        liveLink: "https://universalpowersystems.in/",
        githubLink: "https://github.com/roguekishore/UPS-Lead-Generation-Website",
        image: ups,
        stack: [
            { icon: <FaReact />, name: "React" },
            { icon: <FaJsSquare />, name: "Javascript" },
            { icon: <FaCss3Alt />, name: "CSS" },
        ]
    },
    {
        title: "My Portfolio",
        subtitle: "Page Design",
        description: "My portfolio is one of my favourite works, encompassing all my coding and UI/UX skills.",
        accentColor: "#e4e4e4ff",
        url: "roguekishore.com",
        liveLink: "/",
        githubLink: "https://github.com/roguekishore/Portfolio",
        image: portfolio,
        stack: [
            { icon: <FaReact />, name: "React" },
            { icon: <FaJsSquare />, name: "Javascript" },
            { icon: <SiTailwindcss />, name: "Tailwind" },
            { icon: <FaCss3Alt />, name: "CSS" },
        ]
    }
];

// Helper function to generate gradient CSS variables
const generateGradientVars = (hexColor) => {
    const hexToHSL = (hex) => {
        let r = parseInt(hex.slice(1, 3), 16) / 255;
        let g = parseInt(hex.slice(3, 5), 16) / 255;
        let b = parseInt(hex.slice(5, 7), 16) / 255;
        const max = Math.max(r, g, b), min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
                case g: h = ((b - r) / d + 2) / 6; break;
                case b: h = ((r - g) / d + 4) / 6; break;
                default: h = 0;
            }
        }
        return { h: h * 360, s: s * 100, l: l * 100 };
    };

    const hsl = hexToHSL(hexColor);
    return {
        '--accent-500': `hsla(${hsl.h}, ${Math.min(hsl.s + 5, 100)}%, ${Math.min(hsl.l + 15, 75)}%, 0.35)`,
        '--accent-1000': `hsla(${hsl.h}, ${hsl.s}%, ${Math.max(hsl.l - 30, 5)}%, 0)`,
        '--accent-500-hover': `hsla(${hsl.h}, ${Math.min(hsl.s + 5, 100)}%, ${Math.min(hsl.l + 15, 75)}%, 0.5)`,
        '--accent-1000-hover': `hsla(${hsl.h}, ${hsl.s}%, ${Math.max(hsl.l - 30, 5)}%, 0)`,
    };
};

function HTMLProjects() {
    return (
        <div className="projects-wrapper">
            <div className="purple-line-container-project-top">
                <div className="purple-line-project-top"></div>
            </div>
            <h1 className="hero-title">HTML Projects</h1>
                    <p className="hero-subtitle">
                        built by <a href="https://themaverick.tech" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Kishore N E</a>
                    </p>
            <div className="projects-container">
                <Badge><span className="badge-star">✦</span>HTML Projects</Badge>

                {htmlProjectsData.map((project, index) => (
                    <Card key={index}>
                        <div className="projects-outer">
                            <div className="projects" style={generateGradientVars(project.accentColor)}>
                                <div className="purple-line-container-project">
                                    <div className="purple-line-project"></div>
                                </div>
                                <div className="project-heading">
                                    <div className="project-title">
                                        <h1 className="project-title-main">
                                            {project.title} <span className="bar">|</span>
                                            <span className="project-title-secondary"> {project.subtitle}</span>
                                        </h1>
                                    </div>
                                    <div className="project-description">
                                        <p>{project.description}</p>
                                    </div>
                                    <div className="project-stack">
                                        {project.stack.map((tech, i) => (
                                            <div key={i} className="stack-item">
                                                {tech.icon}
                                                <p>{tech.name}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="project-image">
                                    <MacWindow url={project.url}>
                                        <a href={project.liveLink} target="_blank" rel="noopener noreferrer">
                                            {project.video ? (
                                                <video src={project.video} autoPlay loop muted playsInline className="project-video">
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                <img src={project.image} alt={`${project.title} Demo`} />
                                            )}
                                        </a>
                                    </MacWindow>
                                </div>
                                <div className="project-footer">
                                    <a href={project.liveLink} target="_blank" rel="noopener noreferrer">
                                        <button className="project-button"><MdOutlineLaunch />Live Website</button>
                                    </a>
                                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer">
                                        <button className="project-button"><SiGithub />GitHub Repo</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}

export default HTMLProjects;
